import { AxiosError } from "axios";
import taskManagerApi from "@/features/shared/services/taskManagerApi";
export const fetchPermissions = async (params = {}) => {
    const response = await taskManagerApi.get("/permission", { params: { all: params.all ?? true, ...params } });
    return response.data?.data?.permissions ?? [];
};
export const createPermission = async (payload) => {
    const response = await taskManagerApi.post("/permission", payload);
    return response.data?.data?.permission;
};
export const updatePermission = async (id, payload) => {
    await taskManagerApi.put(`/permission/${id}`, payload);
};
export const deletePermission = async (id) => {
    await taskManagerApi.delete(`/permission/${id}`);
};
export const getPermissionErrorMessage = (error) => {
    if (error instanceof AxiosError) {
        const apiMessage = error.response?.data?.error?.message ?? error.response?.data?.message;
        if (apiMessage) {
            return apiMessage;
        }
    }
    if (error instanceof Error) {
        return error.message;
    }
    return "Une erreur inattendue est survenue.";
};
